import { Tooltip } from "@mantine/core";
import { Link } from "@tanstack/react-router";
import { KeyRound, LayoutGrid, Users } from "lucide-react";

import classes from "./SettingsTabs.module.css";

/**
 * Settings' tabs as links to their two routes, so the URL stays the only state (design-system
 * spec 3.7). The sidebar's Settings item opens the first. Integrations is the live app's third
 * tab and has no screen yet, so it shows disabled with "Coming soon", as the disabled TypeTab.
 */
export function SettingsTabs({ teamId }: { teamId: string }) {
  return (
    <nav aria-label="Settings" className={classes.tabs}>
      <Link to="/teams/$teamId/members" params={{ teamId }} className={classes.tab}>
        <Users size={16} aria-hidden />
        Team
      </Link>
      <Link to="/teams/$teamId/tokens" params={{ teamId }} className={classes.tab}>
        <KeyRound size={16} aria-hidden />
        Access tokens
      </Link>
      {/* A real button, so a keyboard user reaches it and gets the tooltip; aria-disabled rather
          than disabled keeps it focusable and it does nothing when pressed. */}
      <Tooltip label="Coming soon">
        <button type="button" className={classes.tab} aria-disabled="true">
          <LayoutGrid size={16} aria-hidden />
          Integrations
        </button>
      </Tooltip>
    </nav>
  );
}
